import { OfferModel } from '../../../../offer/model/OfferModel';

import { isValidOfferWithPrice } from './isValidOfferWithPrice';

export const getCheapestValidOffer = (offers: OfferModel[]): OfferModel | undefined => {
    return offers.reduce<OfferModel | undefined>((cheapestOffer, offer) => {
        if (!isValidOfferWithPrice(offer)) {
            return cheapestOffer;
        }

        const offerPpl = offer.ppl;

        if (!offerPpl) {
            return cheapestOffer;
        }

        if (!cheapestOffer?.ppl || offerPpl.value < cheapestOffer.ppl.value) {
            return offer;
        }

        return cheapestOffer;
    }, undefined);
};
